import { createStore } from 'zustand'
import { getCookie, setCrossDomainCookie, generateAppUID } from '@gto/helpers/cookies'

type SessionStore = {
  accessToken: string | null
  appUid: string
  setAccessToken: (accessToken: string) => void
  clearAccessToken: () => void
}

const appUidCookieName = 'GTO_APP_UID'
const getAppUID = () => {
  const appUid = getCookie(appUidCookieName)
  if (appUid.length > 0) return appUid

  const newAppUid = generateAppUID()
  setCrossDomainCookie(appUidCookieName, newAppUid, 1095)
  return newAppUid
}

export const sessionStore = createStore<SessionStore>((set, get) => ({
  accessToken: null,
  appUid: getAppUID(),
  setAccessToken: (accessToken: string) => set({ accessToken }),
  clearAccessToken: () => set({ accessToken: null }),
}))
